import React from "react";
import { deleteRide, detailsRide, saveRide } from "../../actions/rides";
import { connect } from "react-redux";
import { faArrowLeft, faBars, faFloppyDisk, faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { getIdInUrl, tempAlWait } from "../../helpers";
import { listParc } from "../../actions/parc";
import AdminHeader from "../../components/AdminHeader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AdminHaut from "../../components/AdminHaut";
import Alert from "../../components/Alert";

class AdminRidesEdit extends React.Component {
    state = {
        menuActive: false,
        opts: [{
            type: 'link',
            ttl: 'Retourner à la liste des attractions',
            ico: faArrowLeft,
            link: "/admin/attractions",
            action: null,
            col: null
        }, {
            type: 'button',
            ttl: "Supprimer l'attraction",
            ico: faTrashCan,
            link: null,
            action: () => {
                if (window.confirm("Souhaitez-vous réellement supprimer cette attraction ?")) {
                    this.setState({
                        alert: tempAlWait()
                    });
                    this.props.deleteRide({id: this.state.id})
                }
            },
            col: "red"
        }],
        form: {
            rideId: '',
            nameOr: '',
            nameFr: '',
            parcId: '',
            isActive: false,
        },
        id: null,
        alert: {
            active: false,
            type: '',
            title: '',
            desc: ''
        },
        parcs: []
    }

    componentDidMount() {
        document.querySelectorAll('.dispAdmin').forEach(el => {
            el.style.display = "none";
        })
        document.getElementById('page').classList.add('pageWithout');

        if (this.props.canContinue) {
            this.setState({
                id: getIdInUrl()
            });
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.canContinue != this.props.canContinue) {
            if (this.props.canContinue) {
                this.setState({
                    id: getIdInUrl()
                });
            }
        }

        if (prevState.id != this.state.id) {
            this.props.detailsRide({id: this.state.id});
            this.setState({
                alert: tempAlWait()
            })
        }
        if (prevProps.redRide != this.props.redRide) {
            this.setState({
                alert: this.props.redRide.alert,
                form: {
                    rideId: this.props.redRide.datas.rideId,
                    nameOr: this.props.redRide.datas.nameOr,
                    nameFr: this.props.redRide.datas.nameFr,
                    parcId: this.props.redRide.datas.parc.id,
                    isActive: this.props.redRide.datas.isActive,
                }
            })
            if (this.props.redRide.alert.type == "succ") {
                this.props.listParc();
            }
        }
        if (prevProps.redParcs != this.props.redParcs) {
            this.setState({
                alert: this.props.redParcs.alert,
                parcs: this.props.redParcs.datas
            });
        }   
        if (prevProps.redSaveRide != this.props.redSaveRide) {
            this.setState({
                alert: this.props.redSaveRide.alert
            })
        }
        if (prevProps.redDelRide != this.props.redDelRide) {
            this.setState({
                alert: this.props.redDelRide.alert
            })
            if (this.props.redDelRide.isNext) {
                setTimeout(() => {
                    window.location.href=`https://${this.props.idtt.slug}.fr/admin/attractions`
                }, 5000);
            }
        }
    }

    handleSubmit = (el) => {
        el.preventDefault();
        this.props.saveRide({
            rideId: this.state.form.rideId,
            nameOr: this.state.form.nameOr,
            nameFr: this.state.form.nameFr,
            parcId: this.state.form.parcId,
            isActive: this.state.form.isActive,
            id: this.state.id,
        });
        this.setState({
            alert: tempAlWait()
        })
    }

    render() {
        return <main className={`admin ${this.state.menuActive && "admin--active"}`}>
            <AdminHeader
                handleClose={(el) => this.setState({menuActive: el})}
                active={this.state.menuActive}
                changeAlert={(el) => this.setState({alert: el})}
                idtt={this.props.idtt}
            />
            {/** Bouton menu **/}
            <button
                title="Ouvrir le menu"
                aria-label="Ouvrir le menu"
                onClick={() => this.setState({menuActive: true})}
                className="adminHdr__btnOpen"
            >
                <FontAwesomeIcon icon={faBars} />
            </button>

            {/** Header de page **/}
            <AdminHaut 
                ttl="Modifier l'attraction"
                options={this.state.opts}
            />
            
            {/** Données de la page **/}
            <div className="admin__ctnr">
                {/** Formulaire **/}
                <form className="admin__form">
                    {/** Identifiant de l'attraction **/}
                    <div className="admin__inpgrp" title="Identifiant de Queue Time" aria-label="Identifiant de Queue Time">
                        <label htmlFor="ride-id" className="admin__lab">
                            Id Queue Time *
                        </label>
                        <input
                            required
                            disabled
                            type="text"
                            placeholder="XXXX"
                            className="admin__input"
                            id="ride-id"
                            value={this.state.form.rideId}
                            onChange={(el) => {
                                this.setState(prevState => ({
                                    form: {
                                        ...prevState.form,
                                        rideId: el.target.value
                                    }
                                }))
                            }}
                        />
                    </div>

                    {/** Nom original **/}
                    <div className="admin__inpgrp" title="Nom original sur Queue time" aria-label="Nom original sur Queue time">
                        <label htmlFor="ride-nameor" className="admin__lab">
                            Nom original *
                        </label>
                        <input
                            required
                            type="text"
                            placeholder="Nom original sur Queue Time"
                            className="admin__input"
                            id="ride-nameor"
                            value={this.state.form.nameOr}
                            onChange={(el) => {
                                this.setState(prevState => ({
                                    form: {
                                        ...prevState.form,
                                        nameOr: el.target.value
                                    }
                                }))
                            }}
                        />
                    </div>

                    {/** Nom français **/}
                    <div className="admin__inpgrp" title="Nom français" aria-label="Nom français">
                        <label htmlFor="ride-namefr" className="admin__lab">
                            Nom français *
                        </label>
                        <input
                            required
                            type="text"
                            placeholder="Nom français"
                            className="admin__input"
                            id="ride-namefr"
                            value={this.state.form.nameFr}
                            onChange={(el) => {
                                this.setState(prevState => ({
                                    form: {
                                        ...prevState.form,
                                        nameFr: el.target.value
                                    }
                                }))
                            }}
                        />
                    </div>

                    {/** Est activé **/}
                    <div className="admin__inpgrp" title="Activation" aria-label="Activation">
                        <label htmlFor="ride-actif" className="admin__lab">
                            Activation
                        </label>
                        <input
                            type="checkbox"
                            className="admin__input admin__input--check"
                            id="ride-actif"
                            checked={this.state.form.isActive}
                            onChange={(el) => {
                                this.setState(prevState => ({
                                    form: {
                                        ...prevState.form,
                                        isActive: el.target.checked
                                    }
                                }))
                            }}
                        />
                    </div>

                    {/** Parc **/}
                    <div className="admin__inpgrp" title="Sélection du parc" aria-label="Sélection du parc">
                        <label htmlFor="ride-parc" className="admin__lab">
                            Parc *
                        </label>
                        <select
                            required
                            className="admin__input admin__input--sel"
                            id="ride-parc"
                            onChange={(el) => {
                                this.setState(prevState => ({
                                    form: {
                                        ...prevState.form,
                                        parcId: el.target.value
                                    }
                                }))
                            }}
                        >
                            <option>-- Choix d'une attraction --</option>
                            {
                                this.state.parcs.map((parc, key) => {
                                    return <option
                                        value={parc.id}
                                        key={`parc-${key}`}
                                        selected={this.state.form.parcId == parc.id}
                                    >
                                        {parc.name}
                                    </option>
                                })
                            }
                        </select>
                    </div>

                    {/** Bouton sauvegarde **/}
                    <button
                        title="Modifier l'attraction"
                        aria-label="Modifier l'attraction"
                        className="admin__btnsave"
                        type="button"
                        onClick={(el) => this.handleSubmit(el)}
                    >
                        <FontAwesomeIcon icon={faFloppyDisk} />
                        <span className="admin__btnsavetxt">Modifier</span>
                    </button>
                </form>
            </div>
            <Alert alert={this.state.alert}/>
        </main>
    }
}

const mapStateToProps = state => {
    return {
        redRide: state.redRide,
        redDelRide: state.redDelRide,
        redSaveRide: state.redSaveRide,
        redParcs: state.redParcs
    }
}

const mapDispatchToProps = {
    detailsRide,
    saveRide,
    listParc,
    deleteRide
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminRidesEdit);
